// Super Admin
export const U_ROLE_SUPER_ADMIN = 1;
// Referral
export const U_ROLE_REFERRAL = 2;
// Business
export const U_ROLE_BUSINESS = 3;
// Normal User
export const U_ROLE_NORMAL = 4;
